exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-8e367c50] {\n  text-align: center;\n}\n.icon-404[data-v-8e367c50] {\n  position: relative;\n  letter-spacing: -1px;\n  line-height: 32vw;\n  font-size: 16vw;\n  font-weight: 100;\n  margin: 0px 0 13.33333vw 0;\n  text-shadow: 0 1px 0 #fff;\n}\n.not-found-img[data-v-8e367c50] {\n  width: 80vw;\n  height: auto;\n}\n", ""]);

// exports
